import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Sidebar from './Sidebar'
import MobileNav from './MobileNav'
import MobileExtras from './MobileExtras'
import ProgressBar from './ProgressBar'
import LanguageSwitcher from './LanguageSwitcher'
import { useClaimForm } from '../context/ClaimFormContext'
import './ClaimFormLayout.css'

const stepProgress = {
  '/step1': 20,
  '/step2': 36,
  '/step3': 50,
  '/no-claim': 50,
  '/step4': 64,
  '/step5': 78,
  '/step6': 90,
  '/step7': 100,
  '/step8': 36,
  '/step9': 68,
  '/step10': 84,
  '/step11': 100,
  '/step12': 100,
}

const stepOrder = [
  '/step1', '/step2', '/step3', '/no-claim',
  '/step4', '/step5', '/step6', '/step7',
  '/step8', '/step9', '/step10', '/step11', '/step12',
]

function getStepProgress(path) {
  return stepProgress[path] ?? 20
}

function ClaimFormLayout() {
  const location = useLocation()
  const { pathname } = location
  const { t } = useTranslation()
  const { data, updateField } = useClaimForm()
  const currentIndex = stepOrder.indexOf(pathname)
  const lastReachedStep = data.lastReachedStep || '/step1'
  const lastIndex = stepOrder.indexOf(lastReachedStep)
  const isMarkedForwardNavigation = location.state?.allowStep === pathname
  const isStep3ToStep4Transition = lastReachedStep === '/step3' && pathname === '/step4'
  const isAuthorizedSuccessStep = isMarkedForwardNavigation && pathname === '/step11'
  const canAdvanceToStep = isMarkedForwardNavigation && (currentIndex === lastIndex + 1 || isStep3ToStep4Transition || isAuthorizedSuccessStep)
  const canAccessUploadStep = pathname === '/step12' && Boolean(sessionStorage.getItem('claimform_upload_case_uuid'))
  const isRestrictedStep = currentIndex !== -1 && currentIndex > lastIndex && !canAdvanceToStep && !canAccessUploadStep
  const progress = getStepProgress(pathname)
  const label = pathname === '/step7' ? t('progress.goodChance') : t('progress.checkClaim')
  const shortLabel = pathname === '/step7' ? t('progress.goodChanceShort') : t('progress.checkClaimShort')

  useEffect(() => {
    if (canAdvanceToStep && pathname !== '/step11' && pathname !== '/step12') {
      updateField('lastReachedStep', pathname)
    }
  }, [canAdvanceToStep, pathname, updateField])

  if (isRestrictedStep) {
    return <Navigate to={lastReachedStep} replace />
  }

  return (
    <div className="claimform-wrapper">
      <LanguageSwitcher />
      <MobileNav />
      <Sidebar basicPct={data.appParams?.basicCommissionPercent ?? 25} />
      <main className="claimform-main">
        <ProgressBar value={progress} label={label} shortLabel={shortLabel} />
        <div className="claimform-form-area">
          <Outlet />
        </div>
      </main>
      <MobileExtras />
    </div>
  )
}

export default ClaimFormLayout
